import {fork, select, take, put} from 'redux-saga/effects';
import {ACEPartner, apmACEPartnerTypes, Location} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';

const updateContractPartnerLocationFlow = function* updateContractPartnerLocationFlow() {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');

    while (true) {
        const {payload} = yield take(contractPartnerActionTypes.INITIATE_UPDATE_CP_LOCATION_DATA);
        const {contractPartnerData, contractPartnerId} = payload;
        const {chosenAddress, location} = contractPartnerData;

        yield fork(
            fetchRequest,
            contractPartnerActionTypes.UPDATE_CP_LOCATION_REQUEST,
            partnerManagementService.updateACEPartner,
            {
                acePartnerData: {
                    ...ACEPartner.objectToPatchDTO({chosenAddress}),
                    // NOTE: do not send the location field in the valid patch format
                    // APM ACEPartner.location vs EF ACEPartner.location
                    // (see @ace-de/entity-types/apm/ACEPartner)
                    location: Location.objectToPatchDTO(location),
                    partnerType: apmACEPartnerTypes.CONTRACT_PARTNER,
                },
                acePartnerId: contractPartnerId,
            },
        );

        const responseAction = yield take([
            contractPartnerActionTypes.UPDATE_CP_LOCATION_REQUEST_SUCCEEDED,
            contractPartnerActionTypes.UPDATE_CP_LOCATION_REQUEST_FAILED,
        ]);

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {acePartnerDTO} = response;

            yield put({
                type: contractPartnerActionTypes.STORE_CONTRACT_PARTNERS,
                payload: {contractPartnerDTOs: [acePartnerDTO]},
            });
        }
    }
};

export default updateContractPartnerLocationFlow;
